import React, { useEffect, useRef, useState } from "react";
import "./Home.css";
import Product from "../Product/Product";
const image = ["https://images-eu.ssl-images-amazon.com/images/I/71DrtLY0SCL._SX1500x600_.jpg", "https://images-eu.ssl-images-amazon.com/images/I/611Hit0i2SL._SX1500x600_.jpg", "https://images-eu.ssl-images-amazon.com/images/I/71FZBWkUf7L._SX1500x600_.jpg", "https://images-eu.ssl-images-amazon.com/images/I/61gsPfvS-EL._SX1500x600_.jpg", "https://images-eu.ssl-images-amazon.com/images/I/61ICZKyjmdL._SX1500x600_.jpg"];

const Home = () => {
    const [index, setIndex] = useState(0);
    const leftA = useRef();
    const rightA = useRef();
    const next = () => {
        rightA.current.style.border = "solid 2.5px #007185";
        rightA.current.style.outline = "solid 2px white";
        if (index == image.length - 1) {
            setIndex(0);
        } else {
            setIndex(index + 1);
        }
    };
    const prev = () => {
        leftA.current.style.border = "solid 2.5px #007185";
        leftA.current.style.outline = "solid 2px white";
        if (index === 0) {
            setIndex(image.length - 1);
        } else {
            setIndex(index - 1);
        }
    };
    useEffect(() => {
        document.addEventListener("click", handleClick, true);
        return document.removeEventListener("click", handleClick);
    }, []);

    const handleClick = (e) => {
        if (!leftA?.current?.contains(e.target) && leftA.current) {
            leftA.current.style.border = "none";
            leftA.current.style.outline = "none";
        }
        if (!rightA?.current?.contains(e.target) && rightA.current) {
            rightA.current.style.border = "none";
            rightA.current.style.outline = "none";
        }
    };
    return (
        <div className="home">
            <div className="home_container">
                <div className="slideButton">
                    <i style={{ color: index % 2 === 0 ? "white" : "black" }} ref={leftA} onClick={prev} className="fa-solid fa-chevron-left sliderArrow left fa-2x"></i>
                    <img className="home_image" src={image[index]} />
                    <i style={{ color: index % 2 === 0 ? "white" : "black" }} ref={rightA} onClick={next} className="fa-solid fa-chevron-right sliderArrow right fa-2x"></i>
                </div>
                <div className="home_row">
                    <Product id="12321337" title="TONULAX Solar Garden Lights ..." price={19.98} rating={5} image="https://images-eu.ssl-images-amazon.com/images/I/71oGQ4MIPsL._AC_SX679_PIbundle-2,TopRight,0,0_SH20_.jpg" />
                    <Product id="12321338" title="Apple 2022 10.9-inch iPad (Wi-Fi + Cellular, 256GB))" price={747.86} rating={5} image="https://images-eu.ssl-images-amazon.com/images/I/61krVpKyNiL._AC_SX522_.jpg" />
                    <Product id="12321339" title={`Introducing Amazon Astro, Household robot for home monitoring...`} price={1599.99} rating={4} image="https://images-eu.ssl-images-amazon.com/images/I/61adlw62wHL._AC_SX679_.jpg" />
                </div>
                <div className="home_row">
                    <Product id="12321341" title="The Innocent Wife: Detective Josie Quinn, Book 16" price={11.62} rating={5} image="https://images-eu.ssl-images-amazon.com/images/I/51WL8XVFcML.jpg" />
                    <Product id="12321342" title="OverTwice Slow Masticating Juicer Cold Press Juice Extractor..." price={139.99} rating={4} image="https://images-eu.ssl-images-amazon.com/images/I/61KiExLNGsL._AC_SL1500_.jpg" />
                </div>
                <div className="home_row">
                    <Product id="12321343" title="Apple AirPods Pro (2nd Generation) Wireless Earbuds..." price={199.99} rating={5} image="https://images-eu.ssl-images-amazon.com/images/I/61f1YfTkTDL._AC_SL1500_.jpg" />
                    <Product id="12321345" title="Fire TV Stick 4K, brilliant 4K streaming quality..." price={49.99} rating={5} image="https://images-eu.ssl-images-amazon.com/images/I/41GYmjbeVSL._AC_SL1000_.jpg" />
                    <Product id="12321346" title={`Fujifilm Instax Mini 11 Instant Camera...`} price={76.95} rating={4} image="https://images-eu.ssl-images-amazon.com/images/I/61PzfzkeGBL._AC_SL1500_.jpg" />
                </div>
                <div className="home_row">
                    <Product id="12321346" title={`Sony 75 Inch 4K Ultra HD TV X90K Series...`} price={1498.0} rating={5} image="https://images-eu.ssl-images-amazon.com/images/I/81KOr7zrq-L._AC_SL1500_.jpg" />
                    <Product id="12321347" title={`Acer Nitro 5 AN515-57-79TD Gaming Laptop...`} price={739.99} rating={4} image="https://images-eu.ssl-images-amazon.com/images/I/81lDOtJRTkL._AC_SL1500_.jpg" />
                </div>
                <div className="home_row">
                    <Product id="12321348" title="CAROLINE CONSTAS Women's Palmer Mini Dress" price={391.0} rating={4} image="https://images-eu.ssl-images-amazon.com/images/I/71MJBBOaJ4L._AC_UY550_.jpg" />
                    <Product id="12321349" title="Gin and Grace 925 Sterling Silver Genuine Aquamarine Pendant with Diamonds for women" price={169.0} rating={5} image="https://images-eu.ssl-images-amazon.com/images/I/61KFa9kEJ5L._AC_UX569_.jpg" />
                    <Product id="12321350" title={`Helly-Hansen 33874 Men's Crew Hooded Midlayer Jacket`} price={142.75} rating={5} image="https://images-eu.ssl-images-amazon.com/images/I/71Lb1MLVosS._AC_SY550._SX._UX._SY._UY_.jpg" />
                </div>
            </div>
        </div>
    );
};

export default Home;
